import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material';

const StaticStepIcon = (props) => {
  const { icon, iconSize } = props;
  const theme = useTheme();
  const fontSize = `${parseInt(iconSize, 16) * 0.5}rem`;
  return (
    <Typography
      fontSize={fontSize}
      fontWeight={600}
      color={theme.palette.primary.A700}
      sx={{
        borderRadius: '50%',
        borderColor: theme.palette.primary.A700,
        fontSize,
      }}
    >
      {icon}
    </Typography>
  );
};

StaticStepIcon.propTypes = {
  icon: PropTypes.number.isRequired,
  iconSize: PropTypes.string,
};
StaticStepIcon.defaultProps = {
  iconSize: '45px',
};

export default StaticStepIcon;
